export const accountType = [
  "ASSET",
  "LIABILITY",
  "EQUITY",
  "INCOME",
  "EXPENSE",
  "PROVISION",
  "TAX",
];

export const accountUsage = ["GL Group", "GL Account"];

export const categories = [
  { id: 1, name: "Daily" },
  { id: 2, name: "Weekly" },
  { id: 3, name: "Monthly" },
  { id: 4, name: "Quarterly" },
  { id: 5, name: "Biannually" },
  { id: 6, name: "Annually" },
];
